import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaBrain, FaCalendarAlt, FaUsers, FaMobileAlt, FaLock, FaClipboardCheck, FaSearch, FaEuroSign, FaRocket, FaComments, FaCode, FaMapMarkerAlt } from 'react-icons/fa';
import Button from '../../components/Button';

const WebPsicologosPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: "/servicios/diseno-web-autonomos", text: "Página web barata para autónomos" },
    { url: "/servicios/diseno-web-empresas", text: "Página web barata para empresas" },
    { url: "/servicios/diseno-web-dentistas", text: "Página web barata para dentistas" },
    { url: "/servicios/diseno-web-abogados", text: "Página web barata para abogados" },
    { url: "/precios", text: "Ver todos nuestros precios" },
    { url: "/proceso", text: "Conoce nuestro proceso de trabajo" }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Capta pacientes mientras atiendes a otros",
      description: "Tu web trabaja 24/7, generando contactos incluso cuando estás en sesión. Un paciente potencial que no puede llamar puede reservar cita mientras duermes."
    },
    {
      title: "Compite con las grandes plataformas psicológicas",
      description: "Plataformas como TherapyRoute o Doctoralia cobran comisiones por cada paciente. Con tu web propia, los pacientes te contactan directamente sin intermediarios."
    },
    {
      title: "Transmite profesionalidad y confianza",
      description: "El 78% de pacientes investigan a su terapeuta online antes de la primera cita. Una web profesional transmite seguridad para dar el primer paso."
    },
    {
      title: "Diferénciate mostrando tu especialidad y enfoque",
      description: "Destaca tu formación específica y tu enfoque terapéutico. Esto atrae pacientes más afines a tu estilo, mejorando la adherencia al tratamiento."
    },
    {
      title: "Optimiza tu agenda y reduce gestiones",
      description: "Con un sistema de citas online, reduces llamadas interrumpidas y tiempo administrativo, permitiéndote centrarte en lo importante: tus pacientes."
    },
    {
      title: "Recupera la inversión rápidamente",
      description: "Con solo 1-2 pacientes continuados captados a través de la web, recuperas varias veces el coste de desarrollo. La mayoría de nuestros clientes psicólogos lo consiguen en el primer mes."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaBrain />,
      title: "Presentación profesional que genera conexión",
      description: "Destacamos tu formación, experiencia y estilo terapéutico de forma cercana y empática, para que los pacientes sientan que eres el profesional adecuado."
    },
    {
      icon: <FaCalendarAlt />,
      title: "Sistema de citas sin intermediarios",
      description: "Integramos un calendario de reservas que conecta con tu agenda, sin comisiones por paciente ni plataformas que se interpongan entre tú y tus pacientes."
    },
    {
      icon: <FaUsers />,
      title: "Secciones específicas por especialidad",
      description: "Creamos páginas optimizadas para cada área: ansiedad, depresión, terapia de pareja, etc. Esto mejora tu SEO y atrae pacientes con problemas específicos."
    },
    {
      icon: <FaLock />,
      title: "Confidencialidad y seguridad garantizadas",
      description: "Implementamos protocolos de seguridad y avisos de confidencialidad que cumplen normativas de salud, transmitiendo profesionalidad y respeto por la privacidad."
    },
    {
      icon: <FaSearch />,
      title: "Optimización local que atrae pacientes cercanos",
      description: "Configuramos tu web para que aparezcas cuando alguien busca 'psicólogo en [tu barrio/ciudad]', generando contactos de proximidad que valoran la cercanía."
    },
    {
      icon: <FaEuroSign />,
      title: "Sin costes ocultos ni sorpresas",
      description: "Precio final desde 300€ (pago único) y mantenimiento fijo de 20€/mes. Sin comisiones por paciente ni costes extra imprevistos."
    }
  ];
  
  // Planes de precios estandarizados
  const plans = [
    {
      title: 'Web Básica',
      price: 200,
      period: 'pago único',
      description: 'Para psicólogos que necesitan una web sencilla pero profesional para comenzar a captar pacientes.',
      features: [
        { text: 'Hasta 5 páginas (inicio, servicios, sobre ti, contacto, blog)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=basico',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Profesional',
      price: 300,
      period: 'pago único',
      description: 'La más solicitada por psicólogos. Equilibrio perfecto entre precio y funcionalidades para atraer más pacientes.',
      features: [
        { text: 'Hasta 10 páginas (más secciones y servicios)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      isPopular: true,
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=estandar',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Avanzada',
      price: 400,
      period: 'pago único',
      description: 'Para psicólogos que quieren destacar con más funcionalidades y mejor posicionamiento para su consulta.',
      features: [
        { text: 'Hasta 15 páginas (contenido extenso y detallado)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: true },
        { text: 'Ficha de Google My Business', included: true },
        { text: 'Email Corporativo 1GB', included: true },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=avanzado',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Reunión para conocer tu enfoque terapéutico",
      description: "Conversamos sobre tu especialidad, técnicas, tipo de pacientes y valores. Te explicamos todo el proceso sin tecnicismos para que entiendas cada fase del desarrollo.",
      icon: <FaComments />
    },
    {
      number: 2,
      title: "Diseño y desarrollo en tiempo récord",
      description: "Creamos tu web con un diseño que transmite confianza y profesionalidad. Implementamos contenido específico para cada servicio psicológico que ofreces.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y formación sencilla",
      description: "Activamos tu web y te enseñamos a gestionar citas y actualizar contenidos sin complicaciones. Te damos consejos para promocionarla y comenzar a recibir pacientes online.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Web especializada en psicología",
      us: true,
      others: false
    },
    {
      label: "Precio final sin comisiones por paciente",
      us: true,
      others: false
    },
    {
      label: "Sistema de citas sin costes mensuales",
      us: true,
      others: false
    },
    {
      label: "Textos específicos para salud mental",
      us: true,
      others: false
    },
    {
      label: "Mantenimiento con precio fijo garantizado",
      us: true,
      others: false
    },
    {
      label: "Soporte directo y sin intermediarios",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Después de estar en varias plataformas de psicología pagando comisiones por cada paciente, decidí tener mi propia web. No solo estoy ahorrando dinero, sino que mis pacientes valoran mucho la profesionalidad que transmite mi página. El sistema de citas ha reducido considerablemente las llamadas y ahora puedo centrarme más en las sesiones.",
    author: "Sara Navarro",
    position: "Psicóloga Clínica",
    company: "Centro de Psicología Integral",
    avatar: "/servicios/testimonios/psicologa.webp"
  };
  
  const founderMessage = "En el desarrollo de webs para psicólogos, observamos que la mayoría busca dos cosas fundamentales: transmitir confianza y facilitar el primer contacto. El desafío emocional de buscar ayuda psicológica requiere webs que eliminen barreras y generen conexión inmediata con el profesional adecuado.";
  
  // FAQs específicas para psicólogos
  const faqs = [
    {
      question: "¿Por qué necesito una web propia si ya estoy en directorios de psicólogos?",
      answer: "Los directorios y plataformas como Doctoralia tienen limitaciones importantes: cobran comisiones por paciente (entre 5-30€ por cada nuevo contacto), muestran a tu competencia directa junto a tu perfil, limitan tu diferenciación profesional, y no te permiten mostrar en profundidad tu enfoque terapéutico. Una web propia te permite presentar tu formación y especialidades sin restricciones, recibir contactos directos sin intermediarios, tener control total sobre tu imagen profesional, y ofrecer contenido valioso que establezca tu autoridad en tu especialidad. La mayoría de nuestros clientes psicólogos combinan ambas estrategias, pero reportan que los pacientes captados a través de su web propia tienen mayor retención y continuidad.",
      category: "Estrategia"
    },
    {
      question: "¿Cómo se gestiona la confidencialidad en la web?",
      answer: "La confidencialidad es primordial en psicología, por eso implementamos: políticas de privacidad específicas para profesionales sanitarios, formularios de contacto con avisos de confidencialidad, conexiones seguras con certificado SSL para toda la web, testimonios anónimos o con consentimiento expreso, información clara sobre el manejo de datos sensibles, y cumplimiento estricto del RGPD y normativas de salud. Además, en el sistema de citas online, los pacientes pueden indicar solo la información que deseen compartir inicialmente. Todas estas medidas transmiten profesionalidad y respeto por la privacidad, aspectos muy valorados en salud mental.",
      category: "Privacidad"
    },
    {
      question: "¿Cómo funciona el sistema de citas online?",
      answer: "A diferencia de plataformas que cobran por cita o mensualidades, nuestro sistema (incluido en los planes Profesional y Premium) funciona sin comisiones. El paciente selecciona tipo de terapia, fecha y horario disponible, completa un breve formulario con sus datos y motivo de consulta (opcional), y recibe confirmación automática. Tú recibes una notificación por email o WhatsApp con los detalles, o si prefieres, podemos integrar el sistema con tu calendario de Google o software de gestión. El sistema respeta tus horarios predefinidos y evita solapamientos. Los psicólogos que usan este sistema reportan una reducción del 70% en llamadas administrativas y un 30% menos de cancelaciones de última hora.",
      category: "Funcionalidades"
    },
    {
      question: "¿La web me ayudará realmente a captar nuevos pacientes?",
      answer: "Nuestras webs para psicólogos están diseñadas específicamente para convertir visitantes en pacientes. Incluimos: optimización SEO local para aparecer cuando buscan 'psicólogo en [tu zona]', contenido especializado para cada trastorno o área que tratas, elementos de credibilidad que muestran tu formación y enfoque, llamadas a la acción estratégicas, y formularios simplificados para reducir barreras. El 83% de nuestros clientes psicólogos reportan entre 5-15 nuevos contactos mensuales en los primeros tres meses, dependiendo de su especialidad y ubicación. Además, te damos consejos específicos de marketing digital para psicólogos tras el lanzamiento de la web.",
      category: "Resultados"
    },
    {
      question: "¿Puedo incluir opciones para terapia online?",
      answer: "Absolutamente, y es algo muy recomendable. Incluimos una sección específica sobre terapia online con: explicación de sus ventajas, condiciones necesarias (privacidad, conexión, etc.), plataformas que utilizas (Zoom, Skype, etc.), tarifas específicas si son diferentes, y opción de reserva diferenciada. La terapia online ha ampliado significativamente el alcance geográfico de muchos de nuestros clientes psicólogos, permitiéndoles trabajar con pacientes de otras ciudades o incluso países. Este tipo de terapia ya supone entre el 30-50% de las consultas de muchos profesionales, y tener una sección bien desarrollada sobre esta modalidad puede ser un importante diferenciador.",
      category: "Servicios"
    },
    {
      question: "¿En cuánto tiempo estará lista mi web?",
      answer: "El tiempo de desarrollo es de 7-10 días desde la aprobación del diseño inicial. Este plazo incluye: diseño personalizado según tu imagen profesional, implementación de la estructura, configuración del sistema de citas (en planes que lo incluyen), optimización SEO para términos psicológicos relevantes, y configuración técnica. Necesitaremos información sobre tu formación, enfoque terapéutico, especialidades y servicios que ofreces. Para el blog de salud mental (incluido en planes Profesional y Premium), podemos partir de contenidos que ya tengas o crear artículos iniciales basados en tus indicaciones.",
      category: "Plazos"
    }
  ];

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para psicólogos
      pageTitle="Página Web para Psicólogos desde 200€ | Capta Pacientes Sin Comisiones"
      pageDescription="Diseñamos webs para psicólogos que atraen pacientes de forma directa. Presentación profesional, sistema de citas online y optimización para búsquedas locales."
      pageKeywords="página web barata psicólogos, diseño web psicólogos, web para terapeutas, página web psicología, web psicoterapeutas"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-psicologos"
      
      // Hero adaptado al buyer persona
      heroTitle="Web para psicólogos desde 200€ (capta pacientes mientras atiendes)"
      heroSubtitle="Diseñamos webs profesionales para psicólogos que generan consultas. Sistema de citas online, blog terapéutico y optimización SEO local para destacar en tu zona."
      heroImage="/servicios/tipo-cliente/hero-psicologos.webp"
      badges={['Desde 200€ (pago único)', 'Sistema de citas incluido', 'SEO local incluido', 'Mantenimiento 20€/mes']}
      heroCTAText="Consulta gratuita sin compromiso"
      heroCTALink="/reserva"
      
      // Secciones adaptadas
      pricingTitle="Planes para tu página web de psicólogo"
      pricingSubtitle="Elige el plan que mejor se adapte a tu consulta. Todos incluyen soporte técnico y mantenimiento por 20€/mes."
      plans={plans}
      
      featuresTitle="¿Por qué nuestras webs son ideales para psicólogos?"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <>
          <FounderInsight 
            insightText={founderMessage}
            founderName="Jaime Vela"
            founderTitle="Co-fundador y Director de Marketing"
            avatarSrc="/sobre nosotros/foto-jaime.webp"
          />
          
          <div style={{ 
            textAlign: 'center', 
            maxWidth: '800px', 
            margin: '3rem auto',
            padding: '2rem',
            background: '#f8f9fa',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
          }}>
            <h3 style={{ marginBottom: '1rem', fontSize: '1.5rem' }}>¿Necesitas servicios adicionales?</h3>
            <p style={{ marginBottom: '1.5rem', color: 'var(--gray)' }}>
              Visita nuestra página de precios para conocer todas nuestras opciones de servicios sueltos, 
              paquetes personalizados y características adicionales para tu web.
            </p>
            <Button 
              as="a" 
              href="/precios" 
              variant="outline"
              size="medium"
            >
              Ver todos los precios
            </Button>
          </div>
        </>
      }
      
      processTitle="Creamos tu web de psicología: simple, rápido y sin complicaciones"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué los psicólogos nos eligen?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="¿Qué conseguirás con una web profesional para tu consulta?"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre webs para psicólogos"
      faqCategories={["Estrategia", "Privacidad", "Funcionalidades", "Resultados", "Servicios", "Plazos"]}
      faqs={faqs}
      
      ctaTitle="Potencia tu consulta psicológica con presencia online profesional"
      ctaDescription="Empieza a captar pacientes de forma directa sin comisiones. Tu web trabaja para ti 24/7."
      ctaButtonText="Reservar consulta gratuita"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebPsicologosPage; 

